export const COMMODITIES = [
  { id: 'cuivre', label: { fr: 'Cuivre', en: 'Copper', zh: '铜' } },
  { id: 'aluminium', label: { fr: 'Aluminium', en: 'Aluminum', zh: '铝' } },
  { id: 'soufre', label: { fr: 'Soufre', en: 'Sulfur', zh: '硫磺' } },
  { id: 'potasse', label: { fr: 'Potasse', en: 'Potash', zh: '钾肥' } },
  { id: 'bitume', label: { fr: 'Bitume', en: 'Bitumen', zh: '沥青' } },
  { id: 'or', label: { fr: 'Or', en: 'Gold', zh: '黄金' } },
  { id: 'autre', label: { fr: 'Autre / Indéfini', en: 'Other / Undefined', zh: '其他 / 未定' } },
];

export const commodityLabel = (id, lang = 'fr') => {
  const c = COMMODITIES.find((x) => x.id === id);
  return c ? c.label[lang] || c.label.fr : id;
};
